import Container from "@/components/ui/Container";
import sphere from "@/assets/mib/sphere.webp";
import keyAstromEmblem from "@/assets/logos/keyastrom-logo.svg";

export default function HeroSection() {
  return (
    <section className="relative flex min-h-[calc(100vh-55px)] flex-col justify-center overflow-hidden rounded-b-[25px] bg-navy-900 min-[478px]:rounded-b-[35px] xl:min-h-[calc(100vh-88px)]">
      <Container>
        <div className="relative pt-10 pb-[60px] min-[478px]:pt-[60px] min-[478px]:pb-[100px] md:pb-[165px] xl:pt-[74px] xl:pb-[182px]">
          <div className="flex w-fit flex-col items-center gap-1 min-[478px]:gap-[6px]">
            <img
              src={keyAstromEmblem}
              alt=""
              aria-hidden="true"
              className="w-[44px] min-[478px]:w-[52px] xl:w-[57px]"
            />
            <span className="whitespace-nowrap font-inter text-coral text-[11px] tracking-[0.03em] min-[478px]:text-[13px] xl:text-[14px]">
              КЛЮЧ-АСТРОМ
            </span>
          </div>

          <h1 className="relative z-10 mt-10 min-[478px]:mt-[97px] md:mt-[53px] xl:mt-[76px] font-bold leading-none text-white text-[34px] tracking-[-0.68px] min-[478px]:text-[42px] min-[478px]:tracking-[-0.84px] md:text-[46px] md:tracking-[-0.92px] xl:text-[70px] xl:tracking-[-1.4px]">
            Модуль информационной безопасности
          </h1>

          <p className="relative z-10 mt-5 min-[478px]:mt-[25px] md:mt-[30px] font-normal text-white text-[16px] leading-[1.4] md:text-[18px] xl:leading-[1.35] md:max-w-[339px] xl:mt-5 xl:max-w-[578px]">
            Расширяет систему мониторинга и добавляет контекст безопасности на
            уровне выполнения кода
          </p>

          <img
            src={sphere}
            alt=""
            aria-hidden="true"
            className="pointer-events-none mx-auto mt-3 w-full max-w-[320px] select-none opacity-50 animate-spin-slow motion-reduce:animate-none min-[478px]:mt-0 min-[478px]:max-w-[450px] md:absolute md:-right-[52px] md:top-[219px] md:mt-0 md:w-[480px] md:max-w-none xl:top-[38px] xl:w-[600px]"
          />

          <div className="relative z-10 flex items-center justify-center rounded-[4px] border-[1.5px] border-coral-400 px-[25px] py-[18px] md:mt-[296px] md:py-[22px] xl:mt-[51px] xl:w-fit xl:justify-start xl:px-[23px]">
            <span className="bg-brand-gradient bg-clip-text text-center font-bold text-transparent text-[16px] leading-[1.3] xl:whitespace-nowrap xl:text-left xl:text-[18px]">
              Помогает понять, какие уязвимости действительно требуют внимания
            </span>
          </div>
        </div>
      </Container>
    </section>
  );
}
